import { TextField } from "@mui/material";
import React, { useState } from "react";
import {
  FlexCenter,
  FlexLeftCenter,
  FlexRowSB,
} from "../../../../constant/CustomeStyle";

const AddWarehouseType = (props) => {
  const {
    values: { Name },
    errors,
    touched,
    handleSubmit,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
  } = props;

  return (
    <div
      style={{
        marginTop: 20,
        width: 702,
      }}
    >
      <form>
        <FlexRowSB>
          <InputBoxN title={"Name"} />
        </FlexRowSB>

        <div style={{ marginTop: 20 }}>
          <FlexCenter
            style={{
              width: 340,
              height: 48,
              borderRadius: 4,
              background: "#52BD9A",
              cursor: "pointer",
              fontSize: 18,
              fontFamily: "Poppins, sans-serif",
              fontWeight: "500",
              color: "#FFF",
            }}
          >
            Save
          </FlexCenter>
        </div>
      </form>
    </div>
  );
};

const InputBoxN = ({ title }) => (
  <div style={{ width: 340 }}>
    <FlexLeftCenter style={{ textAlign: "left", marginBottom: 5 }}>
      <div
        style={{
          fontSize: 16,
          fontFamily: "Poppins, sans-serif",
          color: "#1D1D1D",
        }}
      >
        {title}
      </div>
    </FlexLeftCenter>
    <TextField
      id="outlined-basic"
      variant="outlined"
      fullWidth
      InputProps={{
        style: {
          height: 48,
          background: "#FFF",
          border: "1px solid #CFCFCF",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          borderRadius: 2,
        },
      }}
    />
  </div>
);

export default AddWarehouseType;
